<template>
  	<section class="index_order" ref="dox">
		<van-tabbar v-model="active" @change="changeTabbar" active-color="#4C535D" inactive-color="#4C535D">
			<van-tabbar-item>
				<span>抢单</span>
				<template #icon="props">
					<img :src="props.active ? orderAIcon : orderIcon" />
				</template>
			</van-tabbar-item>
			<van-tabbar-item>
				<span>客户</span>
				<template #icon="props">
					<img :src="props.active ? customerAIcon : customerIcon" />
				</template>
			</van-tabbar-item>
			<van-tabbar-item>
				<span>我的</span>
				<template #icon="props">
					<img :src="props.active ?myAIcon : myIcon" />
				</template>
			</van-tabbar-item>
		</van-tabbar>
	  	<section class="top_c">
		  	<div class="left">
				<img src="../../assets/img/logo.png">
			  </div>
		  	<div class="right" @click="showCityModel">
				<img src="../../assets/img/location_icon.png">
				<p>{{longCityInit(weizhi)||'请选择'}}</p>
			</div>
		</section>
	  	<Swiper />
		<div class="filtrate_box">
			<div class="left">
				实时订单
				<img src="../../assets/img/filtrate_box_line.png">
			</div>
			<div class="right">
				<img src="../../assets/img/filtrate_box_bg.png" class="filtrate_box_bg">
				<p v-for="item in filterTitleList" :key="item.id" :class="{'active': activeId==item.id, 'active1': activeId==3}" @click="filtrateTit(item)">
					<span>{{item.name}}<em v-if="activeId==item.id"></em></span>
					<img src="../../assets/img/filtrate_box_item_bg.png" v-if="activeId==item.id">
				</p>
			</div>
		</div>
		<section class="content" ref="container">
			<div class="filtrate_detail_fixed" v-if="isFixed">
				<p>区间</p>
				<p></p>
				<p></p>
			</div>
			<div class="filtrate_detail" :class="{fixed: isFixed}">
				<div class="fil_tit">
					<p @click="filtrateFn(1)" class="select_filter">
						<span :class="{active_tit: !disabled1 || isSelect1}">金额区间</span>
						<img src="../../assets/img/filtrate_up.png" v-if="!disabled1">
						<img src="../../assets/img/filtrate_down.png" v-if="disabled1 && !isSelect1" >
						<img src="../../assets/img/filtrate_down_a.png" v-if="disabled1 && isSelect1" >
					</p>
					<van-dropdown-menu :close-on-click-overlay="false" :close-on-click-outside="false">
						<van-dropdown-item title="筛选" ref="sliderRef1" :disabled="disabled1" class="van-dropdown-item1">
							<h4>金额<img src="../../assets/img/filter_line.png"></h4>
							<p class="slider_tit" v-if="sliderVal1[0]==maxMoney && sliderVal1[1]==maxMoney">￥50万以上</p>
							<p class="slider_tit" v-else-if="sliderVal1[0]==0 && sliderVal1[1]==0">￥0</p>
							<p class="slider_tit" v-else>￥{{sliderVal1[0]}}万-{{sliderVal1[1]}}万</p>
							<div class="slider_box">
								<van-slider v-model="sliderVal1" range active-color="#FC0E2D" inactive-color="#F1F1F1" :max="maxMoney" bar-height="4" @drag-start="dragStart(1)">
									<template #button>
										<img src="../../assets/img/slider.png">
									</template>
								</van-slider>
							</div>
							<div class="slider_num">
								<p>￥0</p>
								<p>￥50万以上</p>
							</div>
							<div class="slider_list">
								<p v-for="item in sliderNum" :key="item.id" :class="{active: item.id==activeSliderId1}" @click="chooseRange(item, 1)">
									{{item.name}}
									<img src="../../assets/img/angle.png" v-if="item.id==activeSliderId1">
								</p>
							</div>
							<div class="handel">
								<p class="left" @click="clearMoneyFn(1)">清空</p>
								<p class="right" @click="closeFn(1)">完成</p>
							</div>
						</van-dropdown-item>
					</van-dropdown-menu>
				</div>
				<div class="fil_tit">
					<p @click="filtrateFn(2)" class="select_filter">
						<span :class="{active_tit: !disabled2 || isSelect2}">期限区间</span>
						<img src="../../assets/img/filtrate_up.png" v-if="!disabled2">
						<img src="../../assets/img/filtrate_down.png" v-if="disabled2&& !isSelect2" >
						<img src="../../assets/img/filtrate_down_a.png" v-if="disabled2 && isSelect2" >
					</p>
					<van-dropdown-menu :close-on-click-overlay="false" :close-on-click-outside="false">
						<van-dropdown-item title="筛选" ref="sliderRef2" :disabled="disabled2" class="van-dropdown-item1">
							<h4>期限<img src="../../assets/img/filter_line.png"></h4>
							<p class="slider_tit" v-if="sliderVal2[0]==maxTime && sliderVal2[1]==maxTime">36月以上</p>
							<p class="slider_tit" v-else-if="sliderVal2[0]==0 && sliderVal2[1]==0">0月</p>
							<p class="slider_tit" v-else>￥{{sliderVal2[0]}}月-{{sliderVal2[1]}}月</p>
							<div class="slider_box">
								<van-slider v-model="sliderVal2" range active-color="#FC0E2D" inactive-color="#F1F1F1" :max="maxTime" bar-height="4" @drag-start="dragStart(2)">
									<template #button>
										<img src="../../assets/img/slider.png">
									</template>
								</van-slider>
							</div>
							<div class="slider_num">
								<p>0</p>
								<p>36月以上</p>
							</div>
							<div class="slider_list">
								<p v-for="item in sliderTime" :key="item.id" :class="{active: item.id==activeSliderId2}" @click="chooseRange(item, 2)">
									{{item.name}}
									<img src="../../assets/img/angle.png" v-if="item.id==activeSliderId2">
								</p>
							</div>
							<div class="handel">
								<p class="left" @click="clearMoneyFn(2)">清空</p>
								<p class="right" @click="closeFn(2)">完成</p>
							</div>
						</van-dropdown-item>
					</van-dropdown-menu>
				</div>
				<div class="fil_tit">
					<p @click="filtrateFn(3)" class="select_filter">
						<span :class="{active_tit: !disabled3 || isSelect3}">资质条件</span>
						<img src="../../assets/img/filtrate_up.png" v-if="!disabled3 ">
						<img src="../../assets/img/filtrate_down.png" v-if="disabled3&& !isSelect3" >
						<img src="../../assets/img/filtrate_down_a.png" v-if="disabled3 && isSelect3" >
					</p>
					<van-dropdown-menu :close-on-click-overlay="false" :close-on-click-outside="false">
						<van-dropdown-item title="筛选" ref="sliderRef3" :disabled="disabled3" class="van-dropdown-item1">
							<h4>资质<img src="../../assets/img/filter_line.png"></h4>
							<div class="slider_list">
								<p v-for="item in filtrateAssetsList" :key="item.id" :class="{active: assetsActiveList.includes(item.id)}" @click="chooseAssets(item.id)">
									{{item.name}}
									<img src="../../assets/img/angle.png" v-if="assetsActiveList.includes(item.id)">
								</p>
							</div>
							<div class="handel">
								<p class="left" @click="clearMoneyFn(3)">清空</p>
								<p class="right" @click="closeFn(3)">完成</p>
							</div>
						</van-dropdown-item>
					</van-dropdown-menu>
				</div>
				
			</div>
			
			<div class="list" v-if="!isNodata">
				<van-pull-refresh v-model="refreshing" @refresh="onRefresh">
					<van-list v-model="loading" :immediate-check="false" :finished="finished" :finished-text="finishedTxt" @load="loadMore">
						<div v-show="!isLoadingGif">
							<div class="item" v-for="item in list" :key="item.id" @click="skipOrderInfo(item.requireId)">
								<img src="../../assets/img/yangl.png" class="yangli" v-if="!token">
								<img src="../../assets/img/dianhe.png" class="dianhe" v-if="token && item.isDianhe">
								<div class="top">
									<div class="left">
										<p>{{item.name}}</p>
										<div v-if="item.cityStr && item.cityStr!='[]'">
											<img src="../../assets/img/list_icon.png">
											{{item.cityStr}}
										</div>
										<div v-else>
										</div>
										<img src="../../assets/img/discounts.png" class="sign" v-if="item.typeOfSales == 1">
										<img src="../../assets/img/good.png" class="sign" v-else>
									</div>
									<div class="right">
										<span>{{item.applicationTimeMsg}}</span>
									</div>
								</div>
								<div class="mid">
									<div class="left">
										<p class="money">{{item.loanAmount/baseNum}}<span>万</span></p>
										<p class="time">{{item.loanTerm}}<span>个月</span></p>
									</div>
									<div class="right">
										<van-button type="primary" @click="skipOrderInfo(item.requireId)">可抢单</van-button>
										<p v-if="item.typeOfSales == 1"><span>{{(item.discountRate*10).toFixed(2)}}折</span></p>
									</div>
								</div>
								<div class="bot">
									<p v-for="item in item.tag" :key="item.id">{{item.name}}</p>
								</div>
							</div>
						</div>
						<div class="loading_gif" v-show="isLoadingGif">
							<img src="../../assets/img/city_loading.gif" >
							<p>正在加载{{this.params.workCity}}订单数据</p>
						</div>
					</van-list>
				</van-pull-refresh>
			</div>
			<div class="nodata" v-else>
				<img src="../../assets/img/index_nodata.png">
				<p>抢单模式已下线！</p>
				<p style="color:red">请联系客服开通自动推单</p>
			</div>
		</section>
		
		<van-dialog v-model="isShow" title="重要提示" show-cancel-button class="xiyiModel" cancelButtonText="不同意" confirmButtonText="继续" :before-close="beforeClose">
			在使用我们的产品或服务时认真阅读并确认充分理解本协议内容，以便您做出您认为适当的选择。<br>
			我们将向您申请如下权限：<br>
			<p style="font-weight: bold; padding-top:4px">相机/相册读写权限</p>
			我们需要打开您设备的摄像头或相册功能，用于实名认证。以及您下载保存需要的图文。<br>
			<p style="font-weight: bold; padding-top:4px">位置权限</p>
			我们需要打开您的位置功能，用于识别您的身份和匹配基于位置的服务。<br>
			<p style="font-weight: bold; padding-top:4px">推送权限</p>
			我们需要打开您的推送功能，用于及时推送订单相关通知。<br>
			请您仔细阅读以下协议：<span style="color:#428bca" @click="skipWebView">《隐私协议》</span>
		</van-dialog>
		<City :isCityModel="isCityModel" :city="dingwei.weiC" @chooseCity="chooseCity" @closeModel="isCityModel=false" ref="cityRef" @watchPosition="watchPosition" @chooseWeizhi="chooseWeizhi" />
		<section class="upgrade_model" v-if="upgradeModel">
			<van-overlay :show="upgradeModel" />
			<div class="box">
				<div class="top">
					<img src="../../assets/img/versions.png">
				</div>
				<div class="mid">
					<h3>发现新版本</h3>
					<div class="updata_txt">
						<p v-for="item in updateCopyList" :key="item">{{item}}</p>
					</div>
					<p class="sigin" v-if="isUpdata==1"><i></i>旧版本即将停用，请尽快更新</p>
					<p class="sigin" v-else><i></i>当前版本已不支持，请升级</p>
				</div>
				<div class="btn">
					<p class="left" v-if="isUpdata==1" @click="upgradeModel=false">知道了</p>
					<p class="right" @click="skipupWebView">立即升级</p>
				</div>
			</div>
		</section>
		<section class="position_model">
			<van-overlay :show="positionModelShow" @click="positionModelShow = false">
				<div class="wrapper" @click.stop>
					<div class="block">
						<img src="../../assets/img/geo.gif" >
						<p>正在获取你的定位</p>
						<p>用于加载本地实时数据</p>
					</div>
				</div>
			</van-overlay>
		</section>
		
  	</section>
</template>



<script>
import orderServer from "api/order";
import myServer from "api/my";
import Swiper from "components/Swiper";
import City from "components/City"

import customerIcon from "assets/img/customer.png"
import customerAIcon from "assets/img/customer_a.png"
import orderIcon from "assets/img/order.png"
import orderAIcon from "assets/img/order_a.png"
import myIcon from "assets/img/my.png"
import myAIcon from "assets/img/my_a.png"
import filtrateLine3 from "assets/img/filtrate_line.png"
import filtrateLine0 from "assets/img/filtrate_line_y.png"
import filtrateLine1 from "assets/img/filtrate_line_z.png"
import orderJson from "assets/json/order"
import { Notify,Dialog } from 'vant';

export default {
	name: 'index',
	components: {
		Swiper,
		City,
	},
	data() {
		return {
			container: null,
			isShow: false,
			customerIcon,
			customerAIcon,
			customerAIcon,
			orderIcon,
			orderAIcon,
			myIcon,
			orderJson,
			myAIcon,
			active: 0,
			token: '',
			list: [],
			isNodata: 0,
			baseNum: 1000000,
			loading: false,
      		finished: false,
      		finishedTxt: "",
			refreshing: false,
			params: {
				pageNum: 0,
				pageSize: 10,
				workProvince: '',
				workCity: '',
				typeOfSales: '',
				socialStatus: '',
				fundStatus: '',
				carStatus: '',
				houseStatus: '' ,
				insuranceStatus:'',
				licenseStatus:'',
				minAmount: '',
				maxAmount: '',
				minLoanTerm: '',
				maxLoanTerm: '',
			},
			showCity: '',
			weizhi: '',
			weizhiP: '',
			bannerList: [],

			//city
			isCityModel: false,

			//筛选
			filterTitleList: [
				{id: 3, name: '全部', w: 37, url: filtrateLine3},
				{id: 0, name: '优选区', w: 59, url:filtrateLine0},
				{id: 1, name: '折扣区', w: 59, url:filtrateLine1},
			],
			activeId: 3,
			scollInterval: '',
			disabled1: true,
			disabled2: true,
			disabled3: true,
			maxMoney: 50,
			maxTime: 36,
			sliderVal1: [0, 50],
			sliderVal2: [0, 36],
			sliderNum: [
				{id:1, name: '￥5万以下', min:0, max:5},
				{id:2, name: '￥5万-10万', min:5, max:10},
				{id:3, name: '￥10万-20万', min:10, max:20},
				{id:4, name: '￥20万-30万', min:20, max:30},
				{id:5, name: '￥30万-50万', min:30, max:50},
				{id:6, name: '￥50万以上', min:50, max:50},
			],
			sliderTime: [
				{id:1, name: '3月以下', min:0, max:3},
				{id:2, name: '3月-6月', min:3, max:6},
				{id:3, name: '6月-12月', min:6, max:12},
				{id:4, name: '12月-24月', min:12, max:24},
				{id:5, name: '24月-36月', min:24, max:36},
				{id:6, name: '36月以上', min:36, max:36},
			],
			isSelect1: 0,
			isSelect2: 0,
			isSelect3: 0,
			activeSliderId1:0,
			activeSliderId2:0,
			filtrateAssetsList: [
				{id: 'socialStatus', name: '社保'},
				{id: 'fundStatus', name: '公积金'},
				{id: 'carStatus', name: '有车'},
				{id: 'houseStatus', name: '有房'},
				{id: 'insuranceStatus', name: '有保单'},
				{id: 'licenseStatus', name: '有执照'},
			],
			assetsActiveList: [],
			isFixed: 0,
			//列表筛选
			isIos: this.$store.state.isIos,  //在ios中展示 在安卓中不展示
			isPcH5: 0,
			isClear: 0,
			uid:'',
			upgradeModel: false,
			isUpdata: '', //1强，2若
			updateCopyList: '',
			linkUrl: '',
			remdomId:1,
			positionModelShow: false,
			isLoadingGif: false,
			isSetTimeout: 0,
			dingwei: {
				weiC: '',
				weiP: '',
			}
		}
	},
	beforeDestroy() {
		if(this.token) {
			if(!this.params.workProvince) return
			let indexJson = {...this.params}
			indexJson.pageNum = 0
			indexJson.assetsActiveList =[]
			if(this.assetsActiveList.length>0) {
				indexJson.assetsActiveList = this.assetsActiveList
			}
			localStorage.setItem('indexJson'+this.uid, JSON.stringify(indexJson))
		}else {
			if(!this.params.workProvince) return
			let position = {
				province: this.params.workProvince,
				city: this.params.workCity
			}
			localStorage.setItem('position', JSON.stringify(position))
		}
	},
	created() {
		this.token = localStorage.getItem('token')
		let position = localStorage.getItem('position')
		if(!this.token) {
			if(position) {
				position = JSON.parse(position)
				this.params.workProvince = position.province
				this.params.workCity = position.city
				this.weizhiP = this.params.workProvince 
				this.weizhi = position.city
				this.loadMore()
			}else {
				this.isSetTimeout = false
				this.loadMore()
				
			}
		}else {
			myServer.User().then((res) => {
				this.uid = res.data.uid
				let indexFiltratJson = localStorage.getItem('indexJson'+res.data.uid)
				//证明是老用户
				if(indexFiltratJson) {
					indexFiltratJson = JSON.parse(indexFiltratJson)
					if(!position) {
						let positions = {
							province: indexFiltratJson.workProvince,
							city: this.params.workCity
						}
						this.weizhiP = positions.province
						this.weizhi = positions.city
						localStorage.setItem('position', JSON.stringify(positions))
					}else {
						position = JSON.parse(position)
						this.weizhiP = position.province
						this.weizhi = position.city
					}
					this.indexJsonInit(indexFiltratJson)
					return
				}
				if(position && !indexFiltratJson) {
					//新用户选择了位置
					position = JSON.parse(position)
					this.params.workProvince = position.province
					this.params.workCity = position.city
					this.weizhiP = position.province 
					this.weizhi = position.city
					this.loadMore()
				}
				if(!position && !indexFiltratJson) {
					//未定位也不是老用户，出现定位弹框
					// this.weizhiDialogFn()
					this.loadMore()
				}
			})
		}
		if(this.isIos) {
			let isShow = localStorage.getItem('isShow')||'y'
			if(isShow == 'y') {
				this.isShow = true
			}else {
				this.isShow = false
			}
		}else {
			this.isShow = false
		}
	},
	mounted() {
		window.addEventListener('scroll', this.handleScroll)
		this.versionFn()
	},
	methods: {	
		versionFn() {
			let parmas = {
				platform: this.$store.state.versionData.platform,
				market: this.$store.state.versionData.market,
				versionNumber: this.$store.state.versionData.versionNumber,
			}
			// new Date().getHours()
			orderServer.SearchVersion(parmas).then((res) => {
				if(!res.data) return
				this.isUpdata = res.data.versionStatus
				this.updateCopyList = res.data.updateCopy.split('\n')
				this.linkUrl = res.data.linkUrl
				if(!this.isUpdata) {
					this.upgradeModel = false
				}else {
					if(this.isUpdata == 1) {
						let date = localStorage.getItem('dates')||'',
							newDate = new Date().toLocaleDateString();
						if(date != newDate) {
							this.upgradeModel = true
							// 存储当前时间 
							var ndate = new Date().toLocaleDateString()
							localStorage.setItem('dates',ndate)
						}else {
							this.upgradeModel = false
						}	
					}else {
						this.upgradeModel = true
					}
				}
			})
		},
		skipupWebView() {
			window.location.href = this.linkUrl
		},
		romdomList() {
			// this.loading = true
			let arr = []
			this.isNodata = false
			this.params.pageNum++
				if(this.params.pageNum > 10) {
					this.finished = true
					if(this.list.length>9) {
						this.finishedTxt = '已经到底啦，不要再拉了'
					}
				}
			if(this.isSetTimeout) {
				this.isLoadingGif = true
				setTimeout(() => {
					this.listInit(arr)
				},1400)
			}else {
				this.listInit(arr)
				let dingwei = localStorage.getItem('dingwei')
				if(!dingwei) {
					// this.getLocation()
				}else {
					dingwei = JSON.parse(dingwei)
					this.dingwei.weiC = dingwei.weiC
					this.dingwei.weiP = dingwei.weiP
				}
			}			
		},
		listInit(arr) {
			let positions = localStorage.getItem('position')
			if(positions) {
				positions = JSON.parse(positions)
			}
			let s1 = ["王先生","李先生","张先生","刘先生","陈先生","杨先生","黄先生","赵先生","吴先生","周先生",],
					s2 = [2000000,5000000,10000000,20000000,30000000,50000000],
					s3 = [3,6,12,24,36],
					s4  = [
						{ id: 'socialStatus', name: '社保' },
						{ id: 'fundStatus', name: '公积金' },
						{ id: 'houseStatus', name: '房产' },
						{ id: 'licenseStatus', name: '执照' },
						{ id: 'insuranceStatus', name: '保险' },
						{ id: 'carStatus', name: '车产' },
						{ id: 'creditCardStatus', name: '信用卡' },
						{ id: 'jieBeiStatus', name: '借呗' },
						{ id: 'particleLoanStatus', name: '微粒贷' },
						{ id: 'sesameStatus', name: '芝麻分' },
					];
				for (let i = 0; i < 10; i++) {
					let index1 = Math.floor((Math.random() * s1.length)),
						index2 = Math.floor((Math.random() * s2.length)),
						index3 = Math.floor((Math.random() * s3.length)),
						// index4 = Math.floor((Math.random() * s4.length)),
					obj = {
						id: this.remdomId+i,
						name: s1[index1],
						tag: this.getRandomArrayElements(s4, 6),
						cityStr: '',
						loanAmount: s2[index2],
						loanTerm: s3[index3],
						applicationTimeMsg: "刚刚申请"
					};
					if(positions) {
						obj.cityStr = positions.city
					}
					arr.push(obj)
				}
				this.remdomId = this.remdomId+10
				if(this.params.pageNum ==1 || this.refreshing) {
					this.list = arr;
					this.refreshing = false
				}else {
					this.list = this.list.concat(arr) 
				}
				this.isLoadingGif = false
				this.isSetTimeout = false
				this.loading = false
				if(arr.length>=100) {
					this.finished = true
					if(this.list.length>9) {
						this.finishedTxt = '已经到底啦，不要再拉了'
					}
				}
		},
		loadMore() {
			if(this.token && this.params.workCity) {
				this.loading = true
				this.isNodata = false
				this.params.pageNum++
				if(this.params.pageNum > 10) {
					this.finished = true
					if(this.list.length>9) {
						this.finishedTxt = '已经到底啦，不要再拉了'
					}
				}
				if(this.isLoadingGif) {
					setTimeout(() => {
						this.requestIndex()
					},1400)
				}else {
					this.requestIndex()
				}
				
			}else {
				this.romdomList()
			}
		},
		requestIndex() {
			if(this.params.workProvince=='') {
				this.params.workProvince = ""
				this.params.workCity = ""
			}
			orderServer.SearchOrder(this.params).then((res) => {
				if(this.params.pageNum == 1) {
					if(res.data.total==0) {
						this.list = []
						this.isNodata = true
						return
					}
				}
				this.isNodata = false
				this.isLoadingGif = false
				res.data.list.forEach((item) => {
					if(item.city) {
						if(item.city.indexOf('-')!=-1) {
							let city = item.city.split('-')
							item.cityStr = this.longCityInit(city[1])
						}else {
							item.cityStr = this.longCityInit(item.city)
						}
					}
					if(item.labelList&&item.labelList.indexOf('电核')!=-1) {
						item.isDianhe = true
					}else {
						item.isDianhe = false
					}
					item.tag = []
					this.tagInit(item)
				})
				if(this.params.pageNum ==1 || this.refreshing) {
					this.list = res.data.list;
          			this.refreshing = false
				}else {
					this.list = this.list.concat(res.data.list) 
				}
				this.loading = false
				if(res.data.list.length<this.params.pageSize) {
					this.finished = true
					if(this.list.length>9) {
						this.finishedTxt = '已经到底啦，不要再拉了'
					}
				}
			})
		},
		onRefresh() {
			// 清空列表数据
			this.paramsInt()
			this.loading = false
			this.finished = false
			setTimeout(() => {
				this.loadMore()
			},1000)
			
		},
		tagInit(row) {
			if(row.socialStatus ==1) {
				row.tag.push({
					id: 'socialStatus',
					name: '社保'
				})
			}
			if(row.fundStatus ==1) {
				row.tag.push({
					id: 'fundStatus',
					name: '公积金'
				})
			}
			if(row.houseStatus ==1) {
				row.tag.push({
					id: 'houseStatus',
					name: '房产'
				})
			}
			if(row.licenseStatus ==1) {
				row.tag.push({
					id: 'licenseStatus',
					name: '执照'
				})
			}
			if(row.insuranceStatus ==1) {
				row.tag.push({
					id: 'insuranceStatus',
					name: '保险'
				})
			}
			if(row.carStatus ==1) {
				row.tag.push({
					id: 'carStatus',
					name: '车产'
				})
			}
			if(row.creditCardStatus ==1) {
				row.tag.push({
					id: 'creditCardStatus',
					name: '信用卡'
				})
			}
			if(row.jieBeiStatus ==1) {
				row.tag.push({
					id: 'jieBeiStatus',
					name: '借呗'
				})
			}
			if(row.particleLoanStatus ==1) {
				row.tag.push({
					id: 'particleLoanStatus',
					name: '微粒贷'
				})
			}
			if(row.sesameStatus ==1) {
				row.tag.push({
					id: 'sesameStatus',
					name: '芝麻分'
				})
			}
			if(row.tag.length>6) {
				row.tag = this.getRandomArrayElements(row.tag, 6)
			}
		},
		getRandomArrayElements(arr, count) {
			var shuffled = arr.slice(0), i = arr.length, min = i - count, temp, index;
			while (i-- > min) {
				index = Math.floor((i + 1) * Math.random());
				temp = shuffled[index];
				shuffled[index] = shuffled[i];
				shuffled[i] = temp;
			}
			return shuffled.slice(min);
		},

		indexJsonInit(indexFiltratJson) {
			this.params = indexFiltratJson
			this.activeId = this.params.typeOfSales
			if(!this.activeId.toString()) {
				this.activeId = 3
				this.params.typeOfSales = ''
			}
			if(this.params.minLoanTerm.toString()) {
				this[`isSelect${2}`] = 1
				this.sliderVal2 = [this.params.minLoanTerm,this.params.maxLoanTerm]
				this.sliderTime.forEach((item) => {
					if(item.min ==this.params.minLoanTerm &&  item.max ==this.params.maxLoanTerm ) {
						this.activeSliderId2 = item.id
					}
				})
			}
			if(this.params.minAmount.toString()) {
				this[`isSelect${1}`] = 1
				let mix = this.params.minAmount/this.baseNum,
					max = this.params.maxAmount/this.baseNum
				this.sliderVal1 = [mix,max]
				this.sliderNum.forEach((item) => {
					if(item.min ==mix&&  item.max ==max) {
						this.activeSliderId1 = item.id
					}
				})
			}
			if(this.params.assetsActiveList.length>0) {
				this[`isSelect${3}`] = 1
				this.assetsActiveList = this.params.assetsActiveList
				this.params.assetsActiveList.forEach((item) => {
					this.params[item] = 1
				})
			}
			this.loadMore()
		},

		// --------------------- 筛选 ---------------------------
		filtrateTit(row) {
			this.activeId = row.id
			this.paramsInt()
			this.params.typeOfSales = row.id == 3 ?'':row.id
			this.list = []
			this.loadMore()
		},
		handleScroll() {
			if(!this.$refs.container) return
  			var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
			if(scrollTop>=this.$refs.container.offsetTop-50) {
				if(this.isFixed) return
				this.isFixed = true
			}else {
				if(!this.isFixed) return
				this.isFixed = false
			}
		},
		filtrateFn(type) {
			//先检查其余的有没有在打开
			if(type == 1) {
				this.disabled2 = true
				this.disabled3 = true
				this.$refs.sliderRef2.toggle(false);
				this.$refs.sliderRef3.toggle(false);
			}else if(type == 2) {
				this.disabled1 = true
				this.disabled3 = true
				this.$refs.sliderRef1.toggle(false);
				this.$refs.sliderRef3.toggle(false);
			}else if(type == 3) {
				this.disabled1 = true
				this.disabled2 = true
				this.$refs.sliderRef1.toggle(false);
				this.$refs.sliderRef2.toggle(false);
			}
			if(this[`disabled${type}`]) {
				if(!this.isFixed) {
					let top = this.$refs.container.offsetTop-46
						if(this.$refs.dox.offsetHeight-window.screen.availHeight>= top) {
							this.scollInterval = setInterval((params) => {
							document.documentElement.scrollTop += top/10
							if(document.documentElement.scrollTop> top) {
								document.documentElement.scrollTop = top
								clearInterval(this.scollInterval)
								this.scollInterval = ''
							}
						}, 14)
						this.$nextTick(() => {
							this.isFixed = 1		
						})
					}
					setTimeout(() => {
						this[`disabled${type}`] = false
						this.$refs[`sliderRef${type}`].toggle(true);
						
					},400)
				}else {
					this[`disabled${type}`] = false
					this.$refs[`sliderRef${type}`].toggle(true);
				}
			}else {
				this[`disabled${type}`] = true
				this.$refs[`sliderRef${type}`].toggle(false);
			}
		},
		clearMoneyFn(type) {
			//清除所有查询条件
			// this[`disabled${type}`] = true
			// this.isFixed = false
			// this.$refs[`sliderRef${type}`].toggle(false)
			// this[`isSelect${type}`] = false
			
			if(type == 1) {
				this.sliderVal1 = [0,50]
				this.params.maxAmount = ''
				this.params.minAmount = ''
				this.activeSliderId1 = ''

			}else if(type == 2) {
				this.sliderVal2 = [0,36]
				this.params.maxLoanTerm = ''
				this.params.minLoanTerm = ''
				this.activeSliderId2 = ''
			}else if(type == 3) {
				this.assetsActiveList = []
				this.params.socialStatus = ''
				this.params.fundStatus = ''
				this.params.carStatus = ''
				this.params.houseStatus = ''
				this.params.insuranceStatus = ''
				this.params.licenseStatus = ''
			}
			this.isClear = 1
			this.paramsInt()
		},
		closeFn(type) {
			this.$refs[`sliderRef${type}`].toggle(false);
			this[`disabled${type}`] = true
			this.paramsInt()
			this.list = []
			if(type == 1) {
				this.params.minAmount = this.sliderVal1[0]*this.baseNum
				this.params.maxAmount = this.sliderVal1[1]*this.baseNum
				if(this.sliderVal1[0]== 50) {
					this.params.maxAmount= ''
				}
				if(this.isClear) {
					this.params.minAmount = ''
					this.params.maxAmount = ''
					this[`isSelect${type}`] = 0
				}else {
					this[`isSelect${type}`] = 1
				}
			}else if(type == 2) {
				this.params.minLoanTerm = this.sliderVal2[0]
				this.params.maxLoanTerm = this.sliderVal2[1]
				if(this.sliderVal2[0]== 36) {
					this.params.maxLoanTerm= ''
				}
				if(this.isClear) {
					this.params.minLoanTerm = ''
					this.params.maxLoanTerm = ''
					this[`isSelect${type}`] = 0
				}else {
					this[`isSelect${type}`] = 1
				}
			}else if(type == 3) {
				this.params.socialStatus = ''
				this.params.fundStatus = ''
				this.params.carStatus = ''
				this.params.houseStatus = ''
				this.params.insuranceStatus = ''
				this.params.licenseStatus = ''
				this.assetsActiveList.forEach((item) => {
					this.params[item] = 1
				})
				if(this.assetsActiveList.length>0) {
					this[`isSelect${type}`] = 1
				}else {
					this[`isSelect${type}`] = 0
				}
			}
			this.loadMore()
		},
		chooseRange(row, type) {
			this.isClear = 0
			this.$nextTick(() => {
				this[`sliderVal${type}`] = [row.min, row.max]
			})
			this[`activeSliderId${type}`] = row.id
		},
		dragStart(type) {
			this[`activeSliderId${type}`] = 0
			this.isClear = 0
		},

		chooseAssets(id) {
            if(this.assetsActiveList.includes(id)){
				this.assetsActiveList=this.assetsActiveList.filter(e=>{return e != id});
			}else {
				this.assetsActiveList.push(id)
				
			}
		},

		// --------------------- city ---------------------------
		showCityModel() {
			for(let i = 0; i<3; i++) {
				this[`disabled${i+1}`] = true
				this.$refs[`sliderRef${i+1}`].toggle(false);
			}
			this.$refs.cityRef.type = "province"
			this.isCityModel = true
			let dingwei = localStorage.getItem('dingwei')
			if(dingwei) {
				dingwei = JSON.parse(dingwei)
				this.dingwei.weiC = dingwei.weiC
				this.dingwei.weiP = dingwei.weiP
			}
		},

		watchPosition() {
			kk_openLocationSetting((res)=>{
				setTimeout(() => {
					// this.getLocation()
				},3000)
			});
		},
		getLocation() {	
			kk_requestLocationAuthorization((res)=>{
				if(res.code == 1) {
					this.positionModelShow =true
					this.isSetTimeout = true
					kk_userLocation((res)=>{
						this.gaoDePosition(res.lon, res.lat)
					});
				}else if(res.code==0){
					this.params.workProvince = ""
					this.params.workCity = ""
					let positionError = localStorage.getItem('position_error')||2,
						position =localStorage.getItem('position'),
						indexFiltratJson = localStorage.getItem('indexJson'+this.uid);
					if(positionError==2 && !position && !indexFiltratJson) {
						this.positionModelShow =false
						this.weizhiDialogFn()
					}
				}
			});
		},
		chooseWeizhi() {
			this.finished = false
			this.paramsInt()
			this.params.workProvince = this.dingwei.weiP
			this.params.workCity =  this.dingwei.weiC 
			this.weizhi = this.dingwei.weiC 
			this.weizhiP = this.dingwei.weiP 
			let position = {
				province: this.params.workProvince,
				city: this.params.workCity
			}
			localStorage.setItem('position', JSON.stringify(position))
			if(this.token) {
				let indexJson = localStorage.getItem('indexJson'+this.uid)
				if(indexJson) {
					indexJson = JSON.parse(indexJson)
					indexJson.workCity = this.dingwei.weiC
					indexJson.workProvince = this.dingwei.weiP
					localStorage.setItem('indexJson'+this.uid, JSON.stringify(indexJson))
				}
			}
			this.list = []
			this.loadMore()
			this.isCityModel = false
		},
		weizhiDialogFn() {
			Dialog.confirm({
				title: '定位失败',
				message: '请在设置中打开定位权限或在右上角手动选择城市，以便加载实时数据',
				confirmButtonText: '手动选择',
				cancelButtonText: '去设置',
				closeOnClickOverlay: true,
			}).then(() => {
				this.isCityModel = true
				// on confirm
			}).catch((e) => {
				if(e == "cancel") {
					let positionError = localStorage.getItem('position_error')
					if(!positionError) {
						localStorage.setItem('position_error', 1)
					}else {
						localStorage.setItem('position_error',Number(positionError)+2)
					}
					kk_openLocationSetting((res)=>{
						// this.getLocation()
					});
				}
			});
		},
		gaoDePosition(longitude, latitude) {
			orderServer.Maps(longitude,latitude).then((res) => {
				this.paramsInt()
				this.params.workProvince = res.regeocode.addressComponent.province
				this.params.workCity = res.regeocode.addressComponent.city
				this.weizhiP = this.params.workProvince 
				this.weizhi = this.params.workCity 
				let position = {
					province: this.params.workProvince,
					city: this.params.workCity
				}
				localStorage.setItem('position', JSON.stringify(position))
				let dingwei = {
					weiP: this.params.workProvince,
					weiC: this.params.workCity,
				}
				this.dingwei.weiP = this.params.workProvince
				this.dingwei.weiC = this.params.workCity
				localStorage.setItem('dingwei', JSON.stringify(dingwei))
				this.positionModelShow =false
				this.loadMore()
				
			}).catch((err) => {
			})
		},
		chooseCity(province, city) {
			this.list = []
			this.paramsInt()
			this.params.workProvince = province
			this.params.workCity = city
			let position = {
				province: this.params.workProvince,
				city: this.params.workCity
			}
			this.weizhi = position.city
			this.weizhiP = position.province
			localStorage.setItem('position', JSON.stringify(position))
			if(this.token) {
				let indexJson = localStorage.getItem('indexJson'+this.uid)
				if(indexJson) {
					indexJson = JSON.parse(indexJson)
					indexJson.workCity = city
					indexJson.workProvince = province
					localStorage.setItem('indexJson'+this.uid, JSON.stringify(indexJson))
				}
			}else {
				
			}
			this.finished = false
			this.isLoadingGif = true
			this.isSetTimeout = true
			this.isCityModel = false
			this.loading = false
			this.loadMore()
		},
		// --------------------- func ---------------------------
		paramsInt() {
			this.params.pageNum = 0
			this.params.pageSize = 10
		},
		skipOrderInfo(id) {
			if(!this.token) {
				this.$router.push({name:'orderInfo', params:{id: 0}})
			}else {
				this.$router.push({name:'orderInfo', params:{id: id}})
			}
		},
		createTimeInit(time) {
			time = time.replace(/-/g,'/')
			let timeTxt = '',
				newTime = new Date(),
				timed =  new Date(time),
				s1 = newTime.getTime(),
				s2 = timed.getTime(),
				total = (s1 - s2)/1000,
				day = parseInt(total / (24*60*60)),//计算整数天数
				afterDay = total - day*24*60*60,//取得算出天数后剩余的秒数
				hour = parseInt(afterDay/(60*60)),//计算整数小时数
				afterHour = total - day*24*60*60 - hour*60*60,//取得算出小时数后剩余的秒数
				min = parseInt(afterHour/60),//计算整数分
				afterMin = total - day*24*60*60 - hour*60*60 - min*60;//取得算出分后剩余的秒数
			if(day>=1) {
				timeTxt = day+'天前申请'
			}else {
				if(hour<24) {
					timeTxt = hour+'小时前申请'
				}
				if(hour<=1) {
					timeTxt = '1小时前申请'
				}
			}
			if(day>=7) {
				timeTxt = 7+'天前申请'
			}
			return timeTxt
		},
		beforeClose(action, done) {
			localStorage.setItem('isShow', 'n')
			done() 
			// if(this.isPcH5) {
			// 	// this.getLngLatLocation()
			// }else {
				// this.getLocation();
			// }
		},
		skipWebView() {
			this.$router.push({ name: 'webview', params:{t:"隐私协议", src:"https://www.jiexinhome.com/h5/sd/pri.html"}})
		},
		changeTabbar() {
			if(this.active == 1) {
				this.$router.push({ name: 'clientele'})
			}else if(this.active == 2) {
				this.$router.push({ name: 'user'})
			}
		},
		starInit(num) {
			let name = ''
				path = `../../assets/img/${name}.png`
			// star01
			// star1
			// star15
			// star2
			// star25
			// star3
			// star35
			// star4
			// star45
			// star5
			// if(num == 1) 
			return path
		},
		longCityInit(str) {
			if(str == '')  return '请选择'
			if(str.length>5) {
				let newSter = str.substr(0,2)+'...'+str.substr(-1,1)
				return newSter
			}else {
				return str
			}
			
		}
	},
}
</script>

<style lang="scss">
	.index_order {
		padding-bottom: 48px;
		padding-top: 58px;
		.position_model {
			position: relative;
			z-index: 999999;
			.van-overlay {
				background: transparent;
			}
			.wrapper {
				display: flex;
				align-items: center;
				justify-content: center;
				height: 100%;
			}

			.block {
				text-align: center;
				width: 120px;
				height: 120px;
				background: #fff;
				box-shadow: 0px 2px 26px 0px rgba(0, 0, 0, 0.11);
				width: 199px;
				height: 158px;
				border-radius: 8px;
				img {
					display: block;
					width: 69px;
					margin: 0 auto;
					margin-top: 26px;
				}
				p {
					font-size: 13px;
					color: #7D8290;
				}
			}
		}
		.upgrade_model {
			position: fixed;
			top: 0;
			left: 0;
			width: 100%;
			height: 100%;
			z-index: 99999;
			.box {
				position: absolute;
				top: 50%;
				left: 50%;
				transform: translate(-50%, -50%);
				z-index: 2;
				width: 271px;
				background: #fff;
				overflow: hidden;
				border-radius: 8px;
				.top {
					width: 100%;
					img {
						width: 100%;
					}
				}
				.mid {
					text-align: center;
					h3 {
						font-size: 17px;
						color: #2B2F3A;
						padding-top: 22px;
						padding-bottom: 16px;
					}
					.updata_txt {
						text-align: center;
						p {
							color: #7D8290;
							font-size: 14px;
						}
					}
					.sigin {
						color: #575F72;
						font-size: 14px;
						display: flex;
						align-items: center;
						justify-content: center;
						padding: 18px 0;
						i {
							display: block;
							font-style: normal;
							width: 6px;
							height: 6px;
							border: 1Px solid #3A5EEC;
							border-radius: 50%;
							margin-right: 7px;
						}	
					}
					
				}
				.btn {
					display: flex;
					border-top: 1Px solid #F6F6F6;
					p {
						text-align: center;
						font-size: 15px;
						font-weight: bold;
						padding: 16px 0;
					}
					.left {
						flex: 1;
						color: #7D8290;
						border-right: 1Px solid #F6F6F6;
					}
					.right {
						flex: 1;
						color: #3A5EEC;
					}
				}
			}
			
		}
		.xiyiModel {
			.van-dialog__content {
				padding: 20px 30px;
				font-size: 15px;
			}
		}
		.van-tabbar--fixed {
			z-index: 99;
			height: 48px;
		}
		.van-hairline--top-bottom::after, .van-hairline-unset--top-bottom::after {
			display: none;
		}
		.van-tabbar-item__icon {
			margin-bottom: 0;
			img {
				height: 28px;
			}
		}
		.top_c {
			position: fixed;
			height: 46px;
			top: 0;
			left: 0;
			z-index: 99;
			width: 100%;
			background: #ffffff;
			display: flex;
			align-items: center;
			padding: 0 18px;
			justify-content: center;
			.left {
				img {
					display: block;
					width: 37px;
				}
			}
			.right {
				position: absolute;
				right: 18px;
				display: flex;
				align-items: center;
				img {
					display: block;
					width: 12px;
				}
				p {
					padding-left: 4px;
					font-size: 15px;
					font-weight: 500;
					color: #23262E;
				}
			}
		}
		.filtrate_box {
			display: flex;
			justify-content: space-between;
			height: 34px;
			align-items: center;
			margin-top: 21px;
			padding-left: 19px;
			.left {
				position: relative;
				color: #202123;
				font-size: 14px;
				font-weight: bold;
				img {
					position: absolute;
					bottom: 1px;
					left: 0;
					width: 63px;
					z-index: -1;
				}
			}
			.right {
				position: relative;
				display: flex;
				height: 100%;
				align-items: center;
				.filtrate_box_bg {
					position: absolute;
					left: 0;
					top: 0;
					width: 100%;
					height: 100%;
				}
				p {
					position: relative;
					color: #202123;
					font-size: 14px;
					font-weight: bold;
					padding: 0 23px;
					height: 100%;
					line-height: 34px;
					span {
						position: relative;
						z-index: 2;
						em {
							position: absolute;	
							width: 104%;
							height: 4px;
							background: #3A5EEC;
							border-radius: 1Px;
							opacity: 0.42;
							left: 50%;
							transform: translateX(-50%);
							bottom: 0;
							z-index: -1;
						}
					}
					
					img {
						position: absolute;
						bottom: 0px;
						width: 92px;
						height: 38px;
						left: 6px;
						display: block;
					}
				}
				.active {
					font-size: 16px;
				}
				.active1 {
					img {
						left: 0;
					}
				}
			}
		}
		.content {
			
			background: #ffffff;
			// border-top-left-radius: 16px;
			// border-top-right-radius: 16px;
			padding: 0 18px;
			padding-bottom: 20px;
			.van-pull-refresh {
				overflow: inherit;
			}
			.filtrate_detail_fixed {
				padding: 18px 0;
				display: flex;
				align-items: center;
				justify-content: space-between;
				background: #fff;
				p {
					opacity: 0;
					position: relative;
					font-size: 14px;
					color: #575E72;
					display: flex;
					align-items: center;
				}
			}
			.filtrate_detail {
				padding: 18px 0;
				display: flex;
				align-items: center;
				justify-content: space-between;
				.active_tit {
					color: #3A5EEC;
					font-weight: bold;
				}
				.fil_tit {
					position: relative;
					font-size: 14px;
					color: #575E72;
					display: flex;
					align-items: center;
					img {
						width: 10px;
						margin-left: 4px;
					}
					
					.select_filter {
						position: relative;
						z-index: 10;
						display: flex;
						align-items: center;
					}
					.van-dropdown-menu {
						position: absolute;
						left: 0;
						top: 0;
						width: 100%;
						height: 100%;
						z-index: 9;
						.van-dropdown-menu__bar {
							box-shadow:  0 0 0 transparent;
							width: 100%;
							height: 100%;
							opacity: 0;
						}	
						.van-dropdown-item1 {
							.van-popup {
								padding: 0 18px;
								padding-top: 16px;
							}
							h4 {
								position: relative;
								color: #202123;
								font-size: 16px;
								font-weight: bold;
								img {
									position: absolute;
									bottom: 1px;
									left: -4px;
									width: 31px;
								}
							}
							.slider_tit {
								font-size: 16px;
								color: #2B2F3A;
								font-weight: bold;
								text-align: center;
								padding-bottom: 23px;
							}
							.slider_box {
								padding: 0 9px;
							}
							.van-slider__bar {
								img {
									display: block;
									width: 18px;
									height: 18px;
								}
							}
							.slider_num {
								display: flex;
								justify-content: space-between;
								margin-top: 11px;
								p {
									color: #575E72;
									font-size: 12px;
								}
							}
							.slider_list {
								display: flex;
								justify-content: space-between;
								flex-wrap: wrap;
								margin-top: 20px;
								p {
									position: relative;
									width: 104px;
									height: 37px;
									line-height: 37px;
									background: #EFF0F4;
									border-radius: 4px;
									margin-bottom: 16px;
									color: #575E72;
									font-size: 14px;
									text-align: center;
									overflow: hidden;
									img {
										position: absolute;
										bottom: 0;
										right: 0;
										width: 18px;
									}
								}
								.active {
									background: #E1F7FE;
									color: #3A5EEC;
								}
							}
							.handel {
								display: flex;
								height: 74px;
								align-items: center;
								justify-content: space-between;
								border-top: 1Px solid #F1F1F1;
								p {
									width: 160px;
									height: 38px;
									line-height: 38px;
									color: #575E72;
									font-size: 16px;
									text-align: center;
									border-radius: 4Px;
									font-weight: bold;

								}
								.left {
									border: 1Px solid #D2D8EA;

								}
								.right {
									background: #3A5EEC;
									color: #fff;
								}
							}

						}
					}
				}
				.active {
					color: #3A5EEC;

				}
			}
			.fixed {
				padding: 18px;
				position: fixed;
				width: 100%;
				background: #fff;
				z-index: 99;
				top: 45px;
				left: 0;
			}
			
			.list {
				.loading_gif {
					padding: 120px 0;
					img {
						display: block;
						width: 64px;
						margin: 0 auto;
					}
					p {
						padding-top: 23px;
						text-align: center;
						color: #7D8290;
						font-size: 13px;
					}
					// width: ;
				}
				.item {
					position: relative;
					padding: 12px 18px;
					border-radius: 6px;
					margin-bottom: 18px;
					border: 1Px solid #DDE2ED;
					.yangli {
						position: absolute;
						top: 0;
						left: -10px;
						width: 31px;
					}
					.dianhe {
						position: absolute;
						top: 0;
						right: 0;
						width: 27px;
						border-top-right-radius: 5px;
					}
					.top {
						display: flex;
						justify-content: space-between;
						align-items: center;
						.left {
							display: flex;
							align-items: center;
							p {
								color: #2C2D2F;
								font-size: 15px;
								font-weight: bold;
							}
							.star {
								width: 77px;
								margin-left: 8px;
								margin-right: 10px;
							}
							.sign{
								width: 46px;
							}
							div {
								display: flex;
								align-items: center;
								color: #7D8290;
								font-size: 12px;
								padding: 0 8px;
								img {
									display: block;
									width: 10px;
									margin-right: 2px;
									margin-top: 1px;
								}
							}
						}
						.right {
							width: 68px;
							text-align: center;
							color: #7D8290;
							font-style: 12px;
						}
					}
					.mid {
						display: flex;
						align-items: center;
						justify-content: space-between;
						margin-top: 15px;
						.left {
							display: flex;
							align-items: center;
							font-size: 24px;
							font-weight: bold;
							color: #2B2F3A;
							p {
								span {
									font-weight: normal;
									font-size: 14px;
									padding-left: 2px;
									vertical-align: middle;
								}
							}
							.time {
								padding-left: 54px;
							}
						}
						.right {
							position: relative;
							width: 68px;
							height: 28px;
							p {
								position: absolute;
								top: 0;
								right: -30px;
								transform: translateY(-50%);
								width: 42px;
								height: 16px;
								line-height: 16px;
								background: linear-gradient(41deg, #FFD049 0%, #FFB457 100%);
								box-shadow: 0px 0px 0px 0px #FFC06F;
								color: #FC0E2D;
								font-size: 11px;
								font-weight: bold;
								text-align: center;
								border-radius: 10px;
								border-bottom-left-radius: 0;
								span {
									display: block;
									transform: scale(.9);
								}
							}
							.van-button {
								width: 68px;
								height: 28px;
								line-height: 28px;
								border-radius: 4px;
								color: #fff;
								font-size: 14px;
							}
							.van-button--normal {
								padding: 0;
							}
						}
					}
					.bot {
						margin-top: 16px;
						margin-bottom: 6px;
						display: flex;
						p {
							font-size: 12px;
							color: #5D6D98;
							background: #EAEDF4;
							padding: 1px 5px;
							margin-right: 8px;
							border-radius: 1px;
							&:last-of-type {
								margin-right: 0;
							}
						}
					}
				}
				.van-list__finished-text {
					margin-top: -18px;
					padding-bottom: 30px;
				}
			}
			.list {
				.van-list__loading {
					display: none;
				}
			}
			.nodata {
				padding: 120px 0;
				// padding-bottom: 160px;
				img {
					display: block;
					margin: 0 auto;
					width: 66px;
					margin-bottom: 11px;
				}
				p {
					text-align: center;
					color: #7D8290;
					font-size: 13px;
				}
			}
		}
		
	}
</style>


// WEBPACK FOOTER //
// src/views/index/Index.vue